export const ABOUT_PATH = { de: "ueber-uns", en: "about" };
export const ORGAS_PATH = { de: "fuer-orgas", en: "for-organizers" };
export const SUBPAGE_PATH = {
  team: { de: "team", en: "team" },
  charter: { de: "gesellschaftsvertrag", en: "charter" },
  history: { de: "rueckblick", en: "history" },
  reports: { de: "rechenschaftsberichte", en: "accountability-reports" },
  conduct: { de: "verhaltenskodex", en: "code-of-conduct" },
  jugendschutz: { de: "jugendschutzkonzept", en: "youth-protection-concept" },
};
